module.exports = __webpack_public_path__ + "img/Barracuda.cd3a84a.svg";